import * as THREE from 'three';

type TurboSpark = {
  mesh: THREE.Mesh;
  vel: THREE.Vector3;
  life: number;
  maxLife: number;
};

/** Brief cyan spark burst when turbo-building (rapid placements). */
export class FpsBuildTurboVfx {
  private readonly sparks: TurboSpark[] = [];
  private readonly geo = new THREE.SphereGeometry(0.035, 4, 4);
  private readonly mat = new THREE.MeshBasicMaterial({
    color: 0x44f0ff,
    transparent: true,
    opacity: 0.88,
    depthWrite: false,
  });

  constructor(private readonly scene: THREE.Scene) {}

  burst(x: number, y: number, z: number): void {
    const count = 6 + Math.floor(Math.random() * 4);
    for (let i = 0; i < count; i++) {
      const mesh = new THREE.Mesh(this.geo, this.mat.clone());
      mesh.position.set(
        x + (Math.random() - 0.5) * 0.35,
        y + (Math.random() - 0.5) * 0.35,
        z + (Math.random() - 0.5) * 0.35,
      );
      this.scene.add(mesh);
      const angle = Math.random() * Math.PI * 2;
      const spread = 1.2 + Math.random() * 2.4;
      this.sparks.push({
        mesh,
        vel: new THREE.Vector3(
          Math.cos(angle) * spread,
          0.6 + Math.random() * 1.4,
          Math.sin(angle) * spread,
        ),
        life: 0,
        maxLife: 0.14 + Math.random() * 0.12,
      });
    }
  }

  update(dt: number): void {
    for (let i = this.sparks.length - 1; i >= 0; i--) {
      const s = this.sparks[i]!;
      s.life += dt;
      s.mesh.position.addScaledVector(s.vel, dt);
      s.vel.y -= dt * 5.5;
      s.vel.multiplyScalar(1 - dt * 3.8);
      const t = s.life / s.maxLife;
      const mat = s.mesh.material as THREE.MeshBasicMaterial;
      mat.opacity = (1 - t) * 0.88;
      s.mesh.scale.setScalar(0.7 + t * 0.9);
      if (s.life >= s.maxLife) {
        this.scene.remove(s.mesh);
        mat.dispose();
        this.sparks.splice(i, 1);
      }
    }
  }

  dispose(): void {
    for (const s of this.sparks) {
      this.scene.remove(s.mesh);
      (s.mesh.material as THREE.Material).dispose();
    }
    this.sparks.length = 0;
    this.geo.dispose();
    this.mat.dispose();
  }
}
